import React, { Component } from 'react'
import { connect } from 'react-redux'
import { FieldArray, reduxForm } from 'redux-form';
import { Button, Icon, Translate, H2 } from '$common';
import Element from './element';
import Options from './options';
import CSSModules from 'react-css-modules';
import style from './task-form.scss';
import cloneDeep from 'lodash/cloneDeep';

const questionTemplate = {
  label: `${Translate.get('new')} ${Translate.get('question')}`,
  limit: {},
  description: "",
  is_required: true,
  question_type: "text",
  type_group_name: "Text",
  group_name: "Text",
  type_name: "Text",
  is_random: false,
  question_options: [],
  is_closed: false,
  jumpable_id: -1,
  active_jump: [-1, -1],
  media: {
    images: [],
    videos: [],
    voice_records: []
  }
}

const optionTemplate = {
  has_extra_payload: false,
  jump_ids : [],
  label: '',
  optional_label: null
}

const addNewElement = (fields, index) => {
  // window.Intercom('trackEvent', 'ADDED_QUESTION');
  let duplicatedQuestion = questionTemplate;
  duplicatedQuestion.jumpable_id = fields.length + 1;
  fields.insert(index === -1 ? 0 : index+1, duplicatedQuestion);
}

const duplicate = (fields, index, question) => {
  // window.Intercom('trackEvent', 'ADDED_QUESTION');
  let duplicatedQuestion = cloneDeep(question);
  duplicatedQuestion.jumpable_id = fields.length + 1;
  duplicatedQuestion.label = `${question.label} (${Translate.get('copy')})`
  fields.insert(index === -1 ? 0 : index+1, duplicatedQuestion);
}

let QuestionOptions = ({ questionIndex, addBulkOptions, fields }) => {
  return(
    <div>
      <H2 style={{ marginLeft: 0 }}><b>{Translate.get('options')}</b></H2>
      {
        fields.map( (option, index) => (
          <Options
            data={option}
            key={index}
            questionIndex={questionIndex}
            index={index}
          />
        ))
      }
      <Button size="small" type="weak" style={{ textAlign: 'left' }} onClick={() => fields.push(optionTemplate)}>
        + {Translate.get('add_new_option')}
      </Button>
      <Button size="small" type="weak" style={{ textAlign: 'left', marginLeft: '10px' }} onClick={() => addBulkOptions()}>
        + {Translate.get('add_bulk_options')}
      </Button>
    </div>
  )
}

let Elements = ({ questions, fields }) => {
  return(
    <div>
      <div styleName="add-new-element" onClick={() => addNewElement(fields, -1)} id="live-question-add-button">
        <Icon name="plus"/> <span>{Translate.get('add_new_question')}</span>
      </div>
      {
        fields.map( (question, index) => (
          <Element
            data={question}
            key={index}
            order={index+1}
            duplicate={
              <Button type="weak" size="small" onClick={() => duplicate(fields, index, questions[index])} style={{ marginLeft: '5px' }}>
                <Icon name="files-o" /> {Translate.get('duplicate')}
              </Button>
            }
            addNewElement={
              <div styleName="add-new-element" onClick={() => addNewElement(fields, index)} id="live-question-add-button" key={1}>
                <Icon name="plus"/> <span>{Translate.get('add_new_question')}</span>
              </div>
            }
            options={QuestionOptions}
          />
        )
      )}
    </div>
  )
}
Elements = CSSModules(Elements, style);

@CSSModules(style)
class TaskForm extends Component {

  render() {
    const { handleSubmit, questions } = this.props;

    return (
      <form onSubmit={handleSubmit} styleName="root">
        <FieldArray name="questions" component={Elements} questions={questions}/>
      </form>
    )
  }
}

TaskForm = reduxForm({
  form: 'taskForm',
  enableReinitialize: true
})(TaskForm)

TaskForm = connect(
  state => {
    return {
      questions: state.form.taskForm ? state.form.taskForm.values.questions.filter( item => item._destroy !== true ) : []
    }
  }
)(TaskForm)

export default TaskForm



// WEBPACK FOOTER //
// ./src/components/task-form/task-form.js